interface FilterButtonsProps {
    handleOpen?:() => void, 
    applyFilters?:() => Promise<void>
}
const FilterButtons = ({handleOpen, applyFilters}:FilterButtonsProps) => {
  return (
    <div className="flex justify-between mb-[40px]">
        <span className="text-lg font-bold mb-4 ">Filters</span>
        <div className="flex">
          <button onClick={handleOpen} className="resetFilterButton">
            Reset Filters
          </button>
          <button onClick={applyFilters} className="applyFilterButton">
            Apply Filters
          </button>
        </div>
      </div>
  )
}

export default FilterButtons
